import i18n from '@/utils/i18n';
import { StripePrice } from '@/utils/types';
import { StripeElementLocale } from '@stripe/stripe-js';

export function formatPrice(amount: number = 0, currency: string = 'eur'): string {
  const locale = i18n?.language.replace('_', '-');
  const numberFormat = new Intl.NumberFormat([safeLocale(locale)], {
    style: 'currency',
    currency: currency,
    currencyDisplay: 'symbol',
  });
  return numberFormat.format(amount);
}

export function getPriceForCurrency(price: StripePrice, currency = 'eur'): number {
  return (price.currency_options[currency]?.unit_amount || price.amount || 0) / 100;
}

export function getCurrencySymbol(locale: string, currency: string): string {
  return (0)
    .toLocaleString(safeLocale(locale), {
      style: 'currency',
      currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })
    .replace(/\d/g, '')
    .trim();
}

export function getCurrencyName(locale: string, currency: string): string {
  const currencyNameObj = new Intl.DisplayNames(safeLocale(locale), { type: 'currency' });
  const currencyName = currencyNameObj.of(currency);

  return currencyName ? `${currencyName.charAt(0).toUpperCase()}${currencyName.slice(1)}` : '';
}

export function safeLocale(locale: string): StripeElementLocale {
  return locale.replace('_', '-') as StripeElementLocale;
}
